import React, { useEffect, useState } from "react";
import BarChart from "./Chart"; // Assuming you have this import for the Chart component
import { ReactSVG } from "react-svg";
import crownQuerySvg from "../../img/Viva-ai-logo.png";
import selfSvg from "../../img/self-cropped.svg";

function parseTable(htmlStr, just_verify) {
  // Extract headers using regex
  const headerRegex = /<th>(.*?)<\/th>/g;
  let match;
  const headers = [];
  while ((match = headerRegex.exec(htmlStr))) {
    headers.push(match[1]);
  }

  // Extract rows using regex
  const rowRegex = /<tr>([\s\S]*?)<\/tr>/g; // Using [\s\S] to match across lines
  const rows = [];
  let rowData;
  while ((rowData = rowRegex.exec(htmlStr))) {
    const cells = [];
    const cellRegex = /<td>(.*?)<\/td>/g;
    let cellMatch;
    while ((cellMatch = cellRegex.exec(rowData[1]))) {
      cells.push(cellMatch[1]);
    }
    if (cells.length) {
      rows.push(cells);
    }
  }

  let inValidData = false;

  // Create the resulting structure
  const columnData = [];
  for (let i = 1; i < headers.length; i++) {
    const data = rows.map((row) => {
      const value =
        row[i] && row[i].replace("%", "").replace("$", "").replace(/\,/g, "");
      if (isNaN(String(value))) {
        inValidData = true;
      }
      return [row[0], isNaN(value) ? value : parseFloat(value)];
    });
    columnData.push({ key: headers[i], data: data });
  }
  if (just_verify) {
    return !inValidData;
  }
  return columnData;
}

function MessageList({
  messages,
  chatBoxRef,
  promptSuggestions = [],
  fillQuestion,
  disableSendButton,
  longProcessing,
}) {
  useEffect(() => {
    if (chatBoxRef.current) {
      const scrollHeight = chatBoxRef.current.scrollHeight;
      chatBoxRef.current.scrollTop = scrollHeight;
    }
  }, [messages, chatBoxRef]);

  const hasCompleteTable = (content) => {
    return (
      content &&
      content.includes("<table") &&
      content.includes("</table>") &&
      parseTable(content, true)
    );
  };

  return (
    <div className="message-list" ref={chatBoxRef}>
      {messages.length === 0 ? (
        <div className="empty-message-list">
          {disableSendButton && (
            <div
              className="spinner"
              style={{ position: "absolute", bottom: "0px" }}
            ></div>
          )}
          {promptSuggestions.length > 0 && (
            <div className="prompt-suggestions">
              {promptSuggestions.map((suggestion, index) => (
                <div
                  key={index}
                  className={`prompt-suggestion severity-${suggestion.severity.toLowerCase()}`}
                  onClick={() => fillQuestion(suggestion.prompt)}
                >
                  <div className="prompt-title">{suggestion.title}</div>
                  <div className="prompt-content">{suggestion.prompt}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        messages.map((message, index) => {
          if (message.type === "loading") {
            return (
              <div key={index} className="message server">
                <div className="spinner"></div>
              </div>
            );
          }

          // For other types, display the message content
          return (
            <React.Fragment key={index}>
              <div className={`message ${message.type}`}>
                {message.type == "server" && (
                  <ReactSVG src={crownQuerySvg} className="sender-title" />
                )}
                {message.type == "user" && (
                  <ReactSVG src={selfSvg} className="sender-title" />
                )}
                <div dangerouslySetInnerHTML={{ __html: message.content }} />
                {hasCompleteTable(message.content) && (
                  <BarChart data={parseTable(message.content)} />
                )}
              </div>
              {longProcessing && message.type == "server" && (
                <div className="spinner"></div>
              )}
            </React.Fragment>
          );
        })
      )}
    </div>
  );
}

export default MessageList;
